import { Hero } from "@/components/site/Hero";
import { RibbonMarquee } from "@/components/site/Marquee";
import { Fleet } from "@/components/site/Fleet";
import { Gallery } from "@/components/site/Gallery";
import { Itineraries } from "@/components/site/Itineraries";
import { Story } from "@/components/site/Story";
import { Reviews } from "@/components/site/Reviews";
import { Contact } from "@/components/site/Contact";

export default function Home() {
  return (
    <main>
      <Hero />
      <RibbonMarquee />
      <Fleet />
      <Gallery />
      <Story />
      <Itineraries />
      <Reviews />
      <Contact />
    </main>
  );
}
